module.exports = __webpack_public_path__ + "static/media/brand-refresh-delivery.c8660f2d.svg";